import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Add from "../img/add-avatar.png";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from '../firebase';



export const Login = () => {
    const [err, setErr] = useState(false);
  const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);


  const handleSubmit = async (e) => {
    // setLoading(true);
    e.preventDefault();
    const email = e.target[0].value;
    const password = e.target[1].value;

    try {
        await signInWithEmailAndPassword(auth, email, password);
        navigate("/");
    } catch (err) {
      setErr(true);
    //   setLoading(false);
    }
  };

  return (
    <div className="formContainer">
        <div className="formWrapper">
            <span className="logo"><span>Purp</span>Chat</span>
            <span className="title">Login</span>
            <form onSubmit={handleSubmit}>
                <input type="email" placeholder='email'/>
                <input type="password" placeholder='password'/>
                <button>Sign In</button>
                {err && <span class="error">Oops, something went wrong. Please try again.</span>}
            </form>
            <p>Don't have an account? <Link to="/register">Register</Link></p>
        </div>
    </div>
  )
}

export default Login;